import { Button } from '@ekhodealer/ekho-common/rev';

import type { OrdersTableRow } from '@ekhodealer/ekho-common';

import { TextCell } from '@common/components/TextCell';

import { useOrderNavigation } from '../../hooks/useOrderNavigation';

interface TasksCellProps {
	item: OrdersTableRow;
}

export const TasksCell = ({ item }: TasksCellProps) => {
	const { openOrderDetails } = useOrderNavigation();
	const taskCount = item.numberOfTasks || 0;

	if (taskCount === 0) {
		return <TextCell value='--' />;
	}

	const taskText = taskCount === 1 ? '1 task' : `${taskCount} tasks`;

	return (
		<Button
			variant='filled'
			size='medium'
			onPress={() => openOrderDetails(item.orderId)}
			ariaLabel={taskText}>
			<div style={{ width: '100px' }}>{taskText}</div>
		</Button>
	);
};
